import { IApplicationState } from '../../types/redux';

export const getTripId = (state: IApplicationState) => {
  return state.newReview.meta.tripId;
};
